module.exports = __webpack_public_path__ + "img/bingads.7e555dae.png";